module.exports = __webpack_public_path__ + "static/media/stalak_za_romobile.fe12b08c.png";